import { Component } from '@angular/core';

import {AlertController, LoadingController, ModalController, NavParams, ViewController} from 'ionic-angular';

import { ConferenceData } from '../../../providers/conference-data';
import { MissionsData } from '../../../providers/missions-data';
import { UiData } from '../../../providers/ui-data';
import {UserData} from "../../../providers/user-data";

import { JobSelectForm } from '../../utils/job-select/job-select';
import { Geolocation } from '@ionic-native/geolocation';
import {LocationSelectForm} from "../../utils/location-select/location-select";
import {MissionsFilterFormPage} from "./missions-filter-form/missions-filter-form";

declare var google: any;

@Component({
    selector: 'page-missions-filter',
    templateUrl: 'missions-filter.html'
})
export class MissionsFilterPage {
    tracks: Array<{name: string, isChecked: boolean}> = [];
    searchFilters : any;
    test:any;
    lengthRange : any ;
    locationSelectModal: any;
    loading: any = false;
    inited: any = false;
    currently_loading: any = false;

    constructor(
        public confData: ConferenceData,
        public navParams: NavParams,
        public viewCtrl: ViewController,
        public userData: UserData,
        public missionsData: MissionsData,
        public uiData: UiData,
        public modalCtrl: ModalController,
        private geolocation: Geolocation,
        public loadingCtrl: LoadingController,
        public alertCtrl: AlertController
    ) {
        this.test= {'lower':5, 'upper':20};
        // passed in array of track names that should be excluded (unchecked)
        let excludedTrackNames = this.navParams.data;

        this.lengthRange = uiData.getLengthRanges();


    }
    ngAfterViewInit() {

        this.getUserInfos();
    }
    sectorsAsList(){
        if(!this.searchFilters.sector || !this.searchFilters.sector.sectors){
            return "";
        }
        else {
            var str = "";
            let sectors = this.uiData.sectorsList();
            for(let i = 0;i<sectors.length;i++)
            {
                if(this.searchFilters.sector.sectors[sectors[i].slug])
                {
                    if(str!="")str+=", ";
                    str+=sectors[i].name;
                }
            }
            return str+".";
        }
    }
    getUserInfos() {
        var that = this;
        this.userData.load().subscribe(user => {
            that.searchFilters = this.userData.get('searchFilters');
            if(!that.searchFilters.length)that.searchFilters.length={enabled:false};
            if(!that.searchFilters.job)that.searchFilters.job={enabled:false};
            if(!that.searchFilters.sector)that.searchFilters.sector={enabled:false};
            if(!that.searchFilters.salary)that.searchFilters.salary={enabled:false};
        });

    }
    resetFilters() {
        var that = this;
        let prompt = this.alertCtrl.create({
            title: 'Réinitialiser les filtres',
            message: "Tous les filtres seront remis à 0. Souhaitez vous continuer ?",
            buttons: [
                {
                    text: 'Oui, réinitialiser',
                    handler: data => {
                        var saveLocation = that.searchFilters.location;
                        var saveJobs = that.searchFilters.job;
                        that.searchFilters = Object.assign({},that.userData.defaultRegistriesValues.searchFilters);
                        that.searchFilters.location = saveLocation;
                        that.searchFilters.job = saveJobs;
                        that.searchFilters.job.enabled = false;
                        /*that.searchFilters.length.enabled=false;
                        that.searchFilters.salary.enabled=false;
                        that.searchFilters.job.enabled=false;
                        that.searchFilters.job.jobs=[];*/
                    }
                },
                {
                    text: 'Annuler',
                    handler: data => {
                    }
                }
            ]
        });
        prompt.present();
    }
    applyFilters() {

        if(this.searchFilters.job.enabled && (!this.searchFilters.job.jobs || this.searchFilters.job.jobs.length==0))
        {
            this.searchFilters.job.enabled = false;
        }
        if(this.searchFilters.location && this.searchFilters.location.address) {
            if (!this.searchFilters.addresses) this.searchFilters.addresses = {};
            var location_slug : string = ""+this.searchFilters.location.lat+this.searchFilters.location.lng;

            location_slug = location_slug.replace(/\./g,"");
            this.searchFilters.addresses[location_slug]=this.searchFilters.location;
        }

        this.missionsData.setSearchFilters(this.searchFilters);

        // Pass back a new array of track names to exclude
        let excludedTrackNames = this.tracks.filter(c => !c.isChecked).map(c => c.name);
        this.dismiss(true);
    }
    setLoading(state,msg=""){
        if(msg == "")msg = 'Chargement des missions ...';
        if(state)
        {
            this.currently_loading = true;
            this.loading = this.loadingCtrl.create({
                content: msg
            });
            this.loading.present();
        }
        else if(this.loading){
            this.currently_loading = false;
            this.loading.dismiss();
        }
    }
    updateSearchFilters(category)
    {
        /*console.log(this.searchFilters[category]);
        console.log("Change filter for :"+category);
        this.missionsData.updateSearchFilters(category,this.searchFilters[category]);*/
        var that = this;
        if(category=="location-mode"){
            if(this.searchFilters.location.mode=="position")
            {
                that.setLoading(true,'Géolocalisation en cours ...');
                setTimeout(function(){
                    if(that.currently_loading) {
                        that.searchFilters.location.mode = 'address';
                        that.setLoading(false);
                        that.userData.geolocationError();
                    }
                },5000);
                this.geolocation.getCurrentPosition().then((resp) => {
                    this.searchFilters.location.lat = resp.coords.latitude;
                    this.searchFilters.location.lng = resp.coords.longitude;
                    this.searchFilters.location.enabled = true;
                    var geocoder = new google.maps.Geocoder;
                    var latlng = {lat: resp.coords.latitude, lng: resp.coords.longitude};
                    var that = this;
                    geocoder.geocode({'location': latlng}, function(results, status) {

                        if (status === 'OK') {
                            if (results[0]) {
                                that.searchFilters.location.address = results[0].formatted_address;
                                that.setLoading(false);
                            } else {
                                that.searchFilters.location.mode = 'address';
                                that.setLoading(false);
                                that.userData.geolocationError();
                            }
                        } else {
                            that.searchFilters.location.mode = 'address';
                            that.setLoading(false);
                            that.userData.geolocationError();
                        }
                    });
                }).catch((error) => {
                    that.searchFilters.location.mode = 'address';
                    that.setLoading(false);
                    that.userData.geolocationError();

                });
            }
            else
            {
                this.chooseLocation();
            }
        }
        if(category=="location"){
            this.searchFilters.location.enabled=true;
        }
        if(category=="job" && this.searchFilters.job.enabled && (!this.searchFilters.job.jobs || this.searchFilters.job.jobs.length==0))
        {
            this.addJobFilter();
        }
    }
    dismiss(data?: any) {
        // using the injected ViewController this page
        // can "dismiss" itself and pass back data
        this.viewCtrl.dismiss(data);
    }
    addJobFilter()
    {
        let jobSelectModal = this.modalCtrl.create(JobSelectForm, { mode: "certificates" });
        jobSelectModal.onDidDismiss(data => {
            if(data.success)
            {
                if(!this.searchFilters.job.jobs)this.searchFilters.job.jobs=[];
                let found = false;
                for(let y=0; y<this.searchFilters.job.jobs.length;y++){
                    if(this.searchFilters.job.jobs[y]==data.name)found=true;
                }
                if(!found)
                    this.searchFilters.job.jobs.push(data.name);
            }
            else
            {

            }
        });
        jobSelectModal.present();
    }
    removeJobFilter(job)
    {
        var jobs = [];
        if(this.searchFilters.job.jobs)
        for(let i = 0; i < this.searchFilters.job.jobs.length ; i++)
        {
            if(this.searchFilters.job.jobs[i] != job)
            {
                jobs.push(this.searchFilters.job.jobs[i])
            }
        }
        this.searchFilters.job.jobs = jobs;
        if(this.searchFilters.job.jobs.length==0)
        {
            this.searchFilters.job.enabled = false;
        }
    }
    chooseLocation()
    {
        var that = this;
        this.locationSelectModal = this.modalCtrl.create(LocationSelectForm, { mode: "address" });
        this.locationSelectModal.onDidDismiss(place => {
            let locationData = null;
            if (place.geometry !== undefined) {
                let geometry = place.geometry;

                locationData = {
                    lng: geometry.location.lng(),
                    lat: geometry.location.lat(),
                    mode: "address",
                    address:place.formatted_address,
                    enabled: true,
                    distance:50
                };
                this.searchFilters.location = locationData;
            }
            else if(place.mode !== undefined) {
                locationData = place.data
            }

            if(locationData)
                this.searchFilters.location = locationData;
        });
        this.locationSelectModal.present();
    }
    toggle(cat)
    {
        if(!this.searchFilters[cat].enabled)this.searchFilters[cat].enabled=true;
        else this.searchFilters[cat].enabled=false;
    }
    openFilterDetail(cat)
    {
        if(!this.searchFilters[cat].enabled)this.searchFilters[cat].enabled=true;
        let modal = this.modalCtrl.create(MissionsFilterFormPage, { mode: cat, filters:this.searchFilters });
        modal.present();

        modal.onWillDismiss((data: any[]) => {
            if(data)
            {
                this.searchFilters = data;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/missions/missions-filter/missions-filter.ts